import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { 
  GET_LABREQUESTDELIVERYRESULTPARTIALS,
  ADD_NEW_LABREQUESTDELIVERYRESULTPARTIAL,
  UPDATE_LABREQUESTDELIVERYRESULTPARTIAL,
  DELETE_LABREQUESTDELIVERYRESULTPARTIAL
 } from "./actionTypes";
import {
  getLabRequestDeliveryResultPartialsSuccess,
  getLabRequestDeliveryResultPartialsFail,
  addLabRequestDeliveryResultPartialFail,
  updateLabRequestDeliveryResultPartialSuccess,
  updateLabRequestDeliveryResultPartialFail,
  deleteLabRequestDeliveryResultPartialSuccess,
  deleteLabRequestDeliveryResultPartialFail,
  setState,
} from "./actions";
import { getTable, deleteApiCall, patchApiCall } from "../../../services/mainServices"
import { labRequestDeliveryResultAux, labRequestDeliveryResult } from '../../../helpers/adipiBackendUrl'
import { toast } from 'react-toastify'
//Include Both Helper File with needed methods

function* fetchLabRequestDeliveryResultPartials( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable, labRequestDeliveryResult, params.toString());
    yield put(setState(false))
    yield put(getLabRequestDeliveryResultPartialsSuccess(response.items,response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false))
    yield put(getLabRequestDeliveryResultPartialsFail(error));
  }
}

function* updateLabRequestDeliveryResultPartial ({payload: labRequestDeliveryResultPartialObj }) {
  try {
    const { id, recordStatus, ...rest } = labRequestDeliveryResultPartialObj;
    yield call(patchApiCall, `${labRequestDeliveryResultAux}/${id}`, rest);
    const response = yield call(getTable,`${labRequestDeliveryResultAux}/${labRequestDeliveryResultPartialObj.id}`);
    yield put(updateLabRequestDeliveryResultPartialSuccess(response));
    toast.success('Registro actualizado correctamente')
  } catch (error) {
    console.log('Error', error)
    yield put(updateLabRequestDeliveryResultPartialFail(error));
    toast.error('Error al actualizar el registro')
  }
}

function* deleteLabRequestDeliveryResultPartial ({payload: labRequestDeliveryResultPartialObj}) {
  try {
    yield call(deleteApiCall,`${labRequestDeliveryResultAux}/${labRequestDeliveryResultPartialObj.id}`);
    yield put(deleteLabRequestDeliveryResultPartialSuccess(labRequestDeliveryResultPartialObj.id));
    toast.success('Registro borrado correctamente')
  } catch (error) {
    yield put(deleteLabRequestDeliveryResultPartialFail(error));
    toast.error('Error al borrar el registro')
  }
}

function* postingLabRequestDeliveryResultPartial ({ payload: labRequestDeliveryResultObj}) {
  try {
    yield put(setState(true))
    yield put(setState(false))
    toast.success('Registro agregado correctamente')
  } catch (error) {
    yield put(setState(false))
    yield put(addLabRequestDeliveryResultPartialFail(error));
    toast.error('Error al agregar el registro')
  }
}

function* labRequestDeliveryResultPartialsSaga() {
  yield takeEvery(GET_LABREQUESTDELIVERYRESULTPARTIALS, fetchLabRequestDeliveryResultPartials);
  yield takeEvery(ADD_NEW_LABREQUESTDELIVERYRESULTPARTIAL, postingLabRequestDeliveryResultPartial);
  yield takeEvery(UPDATE_LABREQUESTDELIVERYRESULTPARTIAL, updateLabRequestDeliveryResultPartial);
  yield takeEvery(DELETE_LABREQUESTDELIVERYRESULTPARTIAL, deleteLabRequestDeliveryResultPartial);
}

export default labRequestDeliveryResultPartialsSaga;
